"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _TrackingCodeActions = require("../actions/TrackingCodeActions");

var _requestStatusSelectors = require("../selectors/requestStatusSelectors");

var _OnboardingAPI = _interopRequireDefault(require("../api/OnboardingAPI"));

var _hubspotAnalytics = _interopRequireDefault(require("hubspot.analytics.TrackingCode"));

var fetchBasicTrackingCode = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _hubspotAnalytics.default.getDefault,
  initiatingActionType: _TrackingCodeActions.TrackingCodeActionTypes.FETCH_BASIC_TRACKING_CODE,
  requestStatusSelector: _requestStatusSelectors.getFetchBasicTrackingCodeRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _TrackingCodeActions.FetchBasicTrackingCode
}));
var fetchAdvancedTrackingCode = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _hubspotAnalytics.default.getAdvanced,
  initiatingActionType: _TrackingCodeActions.TrackingCodeActionTypes.FETCH_ADVANCED_TRACKING_CODE,
  requestStatusSelector: _requestStatusSelectors.getFetchAdvancedTrackingCodeRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _TrackingCodeActions.FetchAdvancedTrackingCode
}));
var sendTrackingCode = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _OnboardingAPI.default.sendTrackingCode,
  initiatingActionType: _TrackingCodeActions.TrackingCodeActionTypes.SEND_TRACKING_CODE,
  requestStatusSelector: _requestStatusSelectors.getSendTrackingCodeRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _TrackingCodeActions.SendTrackingCode
}));

var _default = (0, _reduxObservable.combineEpics)(fetchBasicTrackingCode, fetchAdvancedTrackingCode, sendTrackingCode);

exports.default = _default;
module.exports = exports.default;